<template>
    <div>
        <div :class="approachingDeadline(date) ? approachingClass : ''">{{ date | humanizeDateTime }}</div>
        <div :class="dateClass">{{ date | dateTimeFilter }}</div>
        <div v-if="!date" :class="emptyClass">{{ emptyText }}</div>
    </div>
</template>

<script>
import { FormatDateHelper, FormatDateTimeLocal, HumanizeDateTimeHelper, DateApproachingDeadline } from '../../js/filters-helpers';

export default {
    name: 'DateTimeDeadline',
    components: {},
    props: {
        date: {  // date/time to use, in ISO STRING format
            type: [String, Object],  // Nov 19 2021 - updated to allow passing in Luxon objects - we updated all filters/methods to check type (string or Luxon object)
            required: true,
        },
        emptyText: {  // text to show when no date is provided
            type: String,
            default: 'None',
        },
        approachingWindow: {  // an object for Luxon time duration to determine when to apply approaching classes
            type: Object,
            default: () => {
                return { days: 1 };
            }
        },
        approachingClass: {  // class(es) to apply to humanized date when inside of approaching window
            type: [String, Array],
            default: 'text-danger',
        },
        dateClass: {  // class(es) to apply to the actual date/time below humanized one
            type: [String, Array],
            default: 'text-muted small',  // use d-none if you want to hide completely
        },
        emptyClass: {  // class(es) to apply to the empty text if there isn't a date
            type: [String, Array],
            default: 'special-text text-black-50',
        }
    },
    filters: {
        dateFilter: function(value) {
            return FormatDateHelper(value);
        },
        dateTimeFilter: function(value) {
            return FormatDateTimeLocal(value);
        },
        humanizeDateTime: function(value) {
            return HumanizeDateTimeHelper(value);
        },
    },
    data: function() {
        return {
            
        }
    },
    methods: {
        approachingDeadline: function(value) {
            let approachingWindow = { days: 1 };
            return DateApproachingDeadline(value, approachingWindow);
        },
    }
}
</script>

<style>

</style>